import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../utils/axios.ts';
import { toast } from 'react-hot-toast';
import getApiErrorMessage from '../utils/helper';

export interface MerryGoRound {
  id: number;
  group_id: number;
  start_date: string;
  is_perpetual: boolean;
  total_rounds: number;
  amount: number;
  frequency_type: string;
  frequency_interval: number;
  frequency_unit?: string;
  contribution_day?: string;
  recipients_per_round: number;
  members: any[];
  [key: string]: any;
}

export const useMerryGoRound = () => {
  return useQuery({
    queryKey: ['merry-go-round'],
    queryFn: async () => {
      const { data } = await api.get('/merry-go-round');
      return data;
    },
  });
};

export const useCreateMerryGoRound = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: Partial<MerryGoRound>) => {
      const { data } = await api.post('/merry-go-round', payload);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['merry-go-round'] });
      toast.success('Merry Go Round created/updated successfully');
    },
    onError: (error) => {
      toast.error(getApiErrorMessage(error));
    },
  });
};

export const useUpdateMerryGoRound = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...payload }: Partial<MerryGoRound> & { id: number }) => {
      const { data } = await api.put(`/merry-go-round/${id}`, payload);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['merry-go-round'] });
      toast.success('Merry Go Round updated successfully');
    },
    onError: (error) => {
      toast.error(getApiErrorMessage(error));
    },
  });
}; 